"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How do I purchase Dustin Royer's books?",
  answer: "All books are available for purchase directly through Amazon. Simply click the 'Buy on Amazon' button on any book's detail page to be redirected to the official product listing for a secure checkout."
}, {
  question: "Are there bulk discounts for ministry groups?",
  answer: "For large orders intended for churches, Bible study groups, or ministry events, please contact us directly through our Contact page. We can provide guidance on bulk purchasing options available through Amazon or other distributors."
}, {
  question: "Do the study guides include video resources?",
  answer: "Many of Dustin's resources, such as 'Rooted in Purpose,' feature companion video content. You can find these supplemental materials under our Resources tab or linked within the books themselves via QR codes."
}, {
  question: "Can I request Dustin for a speaking engagement?",
  answer: "Yes, Dustin is available for ministry events, conferences, and workshops. Please visit our Speaking page to view his current topics and submit a formal inquiry through the booking form."
}, {
  question: "Are digital versions (Kindle) available?",
  answer: "Yes, most titles are available in both high-quality paperback and Kindle formats. This allows you to choose the reading experience that best fits your study habits and lifestyle."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="222080" id="reader-faq" className="bg-background text-foreground px-6 py-20 md:py-32">
      <div className="mx-auto max-w-3xl">
        <h2 className="font-default mb-12 text-3xl font-bold text-primary md:text-4xl tracking-tight">
          Reader Questions
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
              <AccordionTrigger className="font-serif py-6 text-left text-xl font-medium text-foreground transition-colors hover:text-accent hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-default pb-6 text-base leading-relaxed text-secondary">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}